'use client';

import { MediaAirplayButton, MediaCastButton } from 'media-chrome/react';

import { Button } from '@/components/atoms';

import { AirPlayIcon, ChromecastIcon } from './common';
import { CastType } from './types';
import { useCastType } from './useCastType';

interface Props {
  disabled?: boolean;
}

export function MediaChromeCastButton({ disabled = false }: Props) {
  const castType = useCastType();

  if (castType === CastType.AIRPLAY) {
    return (
      <MediaAirplayButton disabled={disabled}>
        <span slot="icon">
          <Button aria-hidden="true" tabIndex={-1} variant="ghost" size="sm">
            <AirPlayIcon />
          </Button>
        </span>
      </MediaAirplayButton>
    );
  }

  if (castType === CastType.CHROMECAST) {
    return (
      <MediaCastButton disabled={disabled}>
        <span slot="icon">
          <Button aria-hidden="true" tabIndex={-1} variant="ghost" size="sm">
            <ChromecastIcon />
          </Button>
        </span>
      </MediaCastButton>
    );
  }
}
